import { useQuery } from 'react-query';
import { useMemo } from 'react';
import { DATA_REQUEST_API } from '../../../config';
import { getTemplateFromString } from '../../../utils/getTemplateFromString';
import { Field, FieldType, getFields, getSchema } from '../../dynamic-form';

export const useDataRequest = (dataRequestId: string) => {
  const { data, isLoading, isError, error } = useQuery(
    ['data-request', dataRequestId],
    async () => {
      const response = await fetch(DATA_REQUEST_API.replace('{token}', dataRequestId), {
        headers: {
          Accept: 'application/json',
        },
      });

      if (!response.ok) {
        return Promise.reject(response.status);
      }

      return response.json();
    },
    { staleTime: 300000, retry: false },
  );

  return useMemo(() => {
    const { fields, submitButton, hasVisibleField, values } = getFields(
      Object.values<Field<FieldType>>(data?.data?.fields || {}),
    );

    const schema = getSchema(fields);

    const template = getTemplateFromString(data?.data?.data_object?.forms?.template);

    return {
      isLoading,
      isError,
      error: error as number | null,
      fields,
      initialValues: values,
      submit: submitButton,
      isValid: hasVisibleField,
      schema,
      template,
    };
  }, [isLoading, data, isError, error]);
};
